import React from 'react';
import {Container, Row} from "react-bootstrap";
import JACarousel from "./Common/JACarousel";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'

class Projects extends React.Component {
    constructor(props) {
        super(props);
        const work = require('./work.json');

        this.state = {
            resume: work.projects,
            index: 0,
        };
    }

    render() {
        return (
            <Container fluid>
                <h2 className={'text-info'}>Projects</h2>
                <Accordion className={'accordion-flush'}>
                    {this.state.resume.map((item, i) => {
                        return (
                            <Card key={'section_' + i}>
                                <Accordion.Toggle as={Card.Header} variant="info-outline" eventKey={i + 1}>
                                    <h3>{item.name}</h3>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={i + 1}>
                                    <Card.Body>
                                        <Container>
                                            {item.images.length ? (
                                                <Row><JACarousel images={item.images}/></Row>
                                            ) : (<></>)
                                            }
                                            {item.bullets.length ? (
                                                <Row>
                                                    <ul>
                                                        {item.bullets.map((bullet, ia) => {
                                                            return (<li key={'point_' + i + '-' + ia}>{bullet}</li>)
                                                        })}
                                                    </ul>
                                                </Row>
                                            ) : (<></>)
                                            }
                                        </Container>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        );
                    })
                    }
                </Accordion>
            </Container>

        );
    }

}

export default Projects;
